import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-58464a6e"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "company-logo" };
const _hoisted_2 = ["src"];
import { AppStore } from '@apparatix/stores/AppStore';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CategoryHome',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("img", {
                    src: _unref(AppStore).companyLogo,
                    alt: "Apparatix company logo"
                }, null, 8, _hoisted_2)
            ]));
        };
    }
});
